import React, { useContext } from 'react';
import { Card, Descriptions, Typography, Tag, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { ClientAuthContext } from '../../../common/constants';

const { Title } = Typography;

export default function ClientProfile() {
    const auth = useContext(ClientAuthContext);
    const client = auth.currentClient;

    if (!client) return null;

    const clientNom = client.type === 'entreprise'
        ? client.nom
        : `${client.prenom || ''} ${client.nom}`.trim();

    return (
        <div>
            <Title level={3}>
                <UserOutlined style={{ marginRight: 8 }} />
                Mon profil
            </Title>

            <Card style={{ maxWidth: 700 }}>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <Avatar size={80} icon={<UserOutlined />} style={{ background: '#1A2B5F', marginBottom: 12 }} />
                    <Title level={4} style={{ margin: 0 }}>{clientNom}</Title>
                    <Tag color={client.type === 'entreprise' ? 'blue' : 'green'} style={{ marginTop: 8 }}>
                        {client.type === 'entreprise' ? 'Entreprise' : 'Particulier'}
                    </Tag>
                </div>

                <Descriptions column={1} bordered size="small">
                    <Descriptions.Item label="Code client">{client.code || '-'}</Descriptions.Item>
                    {client.type === 'entreprise' ? (
                        <Descriptions.Item label="Raison sociale">{client.nom}</Descriptions.Item>
                    ) : (
                        <>
                            <Descriptions.Item label="Nom">{client.nom}</Descriptions.Item>
                            <Descriptions.Item label="Prenom">{client.prenom || '-'}</Descriptions.Item>
                        </>
                    )}
                    <Descriptions.Item label="Telephone">{client.telephone}</Descriptions.Item>
                    {client.telephoneSecondaire && (
                        <Descriptions.Item label="Telephone secondaire">{client.telephoneSecondaire}</Descriptions.Item>
                    )}
                    <Descriptions.Item label="Email">{client.email || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Adresse">{client.adresse || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Ville">{client.ville || 'Abidjan'}</Descriptions.Item>
                    <Descriptions.Item label="Agence">{client.agence?.nom || '-'}</Descriptions.Item>
                </Descriptions>

                <div style={{ marginTop: 24, textAlign: 'center', color: '#999', fontSize: 13 }}>
                    Pour modifier vos informations, contactez votre agence CAP Assurances.
                </div>
            </Card>
        </div>
    );
}
